<div class="form-group input-underline mb-0 position-relative">
    <input maxlength="64" class="form-control mb-1 text-white pr-5" [value]="value" [type]="type" autocomplete="{{ autocomplete }}" (input)="input($event.target)" (blur)="passwordControlInvalid()">
    <label class="text-white">{{ label }}</label>

    <ion-icon name="{{ type === 'password'? 'eye' : 'eye-off' }}" class="position-absolute f24 cursor-pointer" (click)="changeType()" />
</div>

@if (showStrength === true) {
    <div class="password-strength-group" [attr.data-strength]="passStrength">
        <div id="password-strength-meter w-100" class="password-strength-meter d-flex justify-content-stretch">
            <div class="meter-block mr-3"></div>
            <div class="meter-block mr-3"></div>
            <div class="meter-block mr-3"></div>
            <div class="meter-block m-0"></div>
        </div>
        
        <div class="password-strength-message mt-2 text-right">{{ passwordDesc[passStrength] }}</div>
    </div>
}

@if (errorMsg) {
    <label class="is-invalid">{{ errorMsg }}</label>
}

